<template>
  <div class="app-scene">
    <div class="app-display">
      <div class="app-container">
        <div class="title">
          满足多样化应用场景
        </div>
        <div class="app-row">
          <div class="app-box" @click="onClickAppBox(index)" :class="index === activeIndex ? 'active' : ''"
               v-for="(item, index) in appList" :key="index">
            <div class="box-icon">
              <img :src="item.icon" alt="">
            </div>
            <div class="box-title">
              {{ item.name }}
            </div>
            <div class="box-active-line"></div>
          </div>
          <!--<div class="app-box-more">-->
          <!--. . .-->
          <!--</div>-->
        </div>
      </div>
    </div>
    <div class="app-detail">
      <div class="app-container">
        <div class="app-detail-wrap">
          <div class="detail-img">
            <img :src="activeApp.img" alt="">
          </div>
          <div class="detail-content">
            <div class="detail-row" v-for="(row, rowIndex) in detailRowList" :key="rowIndex">
              <div class="row-box" v-for="(item, index) in row" :key="index">
                <div class="box-title">
                  {{ item.title }}
                </div>
                <div class="box-desc">
                  {{ item.desc }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'introduction',

    data () {
      return {
        activeIndex: 0,
        appList: [
          {
            icon: require('../image/ic_gjj.png'),
            name: '公积金',
            img: require('../image/gui_gjj.png'),
            detailList: [
              {
                title: '缴存明细',
                desc: '查询公积金缴存明细',
              }, {
                title: '可贷额度计算',
                desc: '计算公积金可贷额度',
              }, {
                title: '贷款还款明细',
                desc: '查询贷款还款情况',
              }, {
                title: '贷款信息',
                desc: '查询贷款信息',
              }, {
                title: '还款计划查询',
                desc: '查询还款计划',
              }, {
                title: '预约信息查询',
                desc: '查询预约记录',
              }, {
                title: '预约信息查询',
                desc: '查询预约记录',
              }, {
                title: '公积金提取申请',
                desc: '非首次提取线上申请',
              }],
          },
          {
            icon: require('../image/ic_sb.png'),
            name: '社保',
            img: require('../image/gui_shebao.png'),
            detailList: [
              {
                title: '医疗保险缴费状态',
                desc: '查询个人医保缴费状态',
              }, {
                title: '养老保险缴费状态',
                desc: '查询个人养老保险缴费状态',
              }, {
                title: '社保缴费明细',
                desc: '查询个人社保缴费明细',
              }, {
                title: '生育保险缴费状态',
                desc: '查询个人生育保险缴费状态',
              }, {
                title: '失业保险缴费状态',
                desc: '查询个人失业保险交给状态',
              }, {
                title: '定点医院信息',
                desc: '查询定点医院信息',
              }, {
                title: '定点药店信息',
                desc: '查询定点药店信息',
              }, {
                title: '养老金领取资格认证',
                desc: '查询个人养老金提取资格',
              }],
          },
          {
            icon: require('../image/ic_jg.png'),
            name: '交管',
            img: require('../image/gui_jiaoguan.png'),
            detailList: [
              {
                title: '车辆违法查询',
                desc: '查询车辆违法信息',
              }, {
                title: '车辆违法处理',
                desc: '处理车辆违法事项',
              }, {
                title: '驾驶人违法查询',
                desc: '查询驾驶人违法记录',
              }, {
                title: '驾驶人违法交罚',
                desc: '缴纳交通违法罚款',
              }, {
                title: '超龄换证',
                desc: '超龄换证申请',
              }, {
                title: '车辆年审预约',
                desc: '车辆年审预约登记',
              }, {
                title: '补换领行驶证',
                desc: '补换领行驶证申请',
              }, {
                title: '补换领车辆号牌',
                desc: '补换领车辆号牌申请',
              }],
          },
          {
            icon: require('../image/ic_crj.png'),
            name: '出入境',
            img: require('../image/gui_churujing.png'),
            detailList: [
              {
                title: '办证进度查询',
                desc: '出入境办证进度查询',
              }, {
                title: '往来港澳个人旅游签注',
                desc: '往来港澳个人旅游签注申请',
              }, {
                title: '往来港澳商务再次签注',
                desc: '往来港澳商务再次签注申请',
              }, {
                title: '往来港澳通行证预约',
                desc: '往来港澳通行证预约办理',
              }, {
                title: '往来台湾团体旅游签注',
                desc: '往来台湾团体旅游签注申请',
              }, {
                title: '护照预约',
                desc: '护照业务办理预约',
              }, {
                title: '往来港澳团体旅游签注',
                desc: '往来港澳团体旅游签注申请',
              }, {
                title: '出入境办证点一体机',
                desc: '出入境办证点查询',
              }],
          },
          {
            icon: require('../image/ic_hz.png'),
            name: '户政',
            img: require('../image/gui_huzheng.png'),
            detailList: [
              {
                title: '补领居住证',
                desc: '补领居住证申请',
              }, {
                title: '换领居住证',
                desc: '换领居住证申请',
              }, {
                title: '临时身份证明',
                desc: '临时身份证明出示',
              }, {
                title: '出生登记',
                desc: '出生登记办理',
              }, {
                title: '无犯罪记录证明',
                desc: '无犯罪记录证明开具申请',
              }, {
                title: '签注居住证',
                desc: '居住证签注申请',
              }, {
                title: '重名查询',
                desc: '重名情况查询',
              }, {
                title: '换领户口簿',
                desc: '补/换领户口簿申请',
              }],
          },
          {
            icon: require('../image/ic_ds.png'),
            name: '地税',
            img: require('../image/gui_dishui.png'),
            detailList: [
              {
                title: '个税业务',
                desc: '个税业务办理申请',
              }, {
                title: '社保税务',
                desc: '社保税务办理申请',
              }, {
                title: '车船税业务',
                desc: '车船税办理申请',
              }, {
                title: '契税业务',
                desc: '契税业务办理',
              }, {
                title: '办税预约',
                desc: '线下办税提前预约',
              }],
          },
          {
            icon: require('../image/ic_cl.png'),
            name: '助残',
            img: require('../image/gui_zhucan.png'),
            detailList: [
              {
                title: '残疾证办理申请',
                desc: '申请办理残疾证',
              }, {
                title: '残疾等级变更申请',
                desc: '残疾等级变更申请',
              }, {
                title: '残疾证查询',
                desc: '残疾证信息查询',
              }, {
                title: '残疾证注销',
                desc: '注销残疾证申请',
              }, {
                title: '残疾证挂失',
                desc: '残疾证挂失申请',
              }, {
                title: '残疾人生活补贴申请',
                desc: '贫困残疾人生活补贴申请',
              }, {
                title: '重度残疾人护理补贴申请',
                desc: '重度残疾人护理补贴申请',
              }, {
                title: '残疾人税收减免',
                desc: '残疾人税收减免申请',
              }],
          },
          {
            icon: require('../image/ic_hy.png'),
            name: '婚姻',
            img: require('../image/gui_hunyin.png'),
            detailList: [
              {
                title: '结婚登记预约',
                desc: '结婚登记预约',
              }, {
                title: '离婚登记预约',
                desc: '离婚登记预约',
              }, {
                title: '补领《结婚证》预约',
                desc: '申请补领《结婚证》预约',
              }, {
                title: '补领《离婚证》预约',
                desc: '申请补领《离婚证》预约',
              }, {
                title: '《婚姻登记记录证明》预约',
                desc: '申请《婚姻登记记录证明》预约',
              }, {
                title: '婚姻业务预约查询',
                desc: '取消已提交的婚姻业务预约',
              }, {}, {}],
          },
        ],
      };
    },

    computed: {
      activeApp () {
        return this.appList && this.appList[this.activeIndex];
      },
      detailRowList () {
        const activeApp = this.appList && this.appList[this.activeIndex];
        if (activeApp && activeApp.detailList) {
          const detailRowList = [];
          let temp = [];
          activeApp.detailList.forEach((item, index) => {
            if (temp.length <= 3) {
              temp.push(item);
            }

            if (temp.length === 4 || index === (activeApp.detailList.length - 1)) {
              detailRowList.push(this.deepClone(temp));
              temp = [];
            }
          });
          return detailRowList;
        }
        return [];
      },
    },

    methods: {
      deepClone (src) {
        return JSON.parse(JSON.stringify(src));
      },

      onClickAppBox (index) {
        this.activeIndex = index;
        console.log('detailRowList', this.detailRowList);
      },
    },
  };
</script>

<style lang="less" src="../styles/app-scene.less"></style>
